import { MusicNoteIdentity, NoteAccidental } from "../../wasm/pkg/wasm";

export const MINOR_ROOTS_WITH_SHARP_FLAT_CHOICE: Array<MusicNoteIdentity> = ["DsharpEflat"];
// ["AsharpBflat", "GsharpAflat"]; // this can technically vary but I don't care.

export function chooseSharpsFlatsGivenMinorRoot(id: MusicNoteIdentity, userPref?: NoteAccidental): NoteAccidental {
  switch (id) {
    case "A":
      return "Natural";
    case "AsharpBflat":
      return userPref || "Flat";
    case "B":
      return "Sharp";
    case "C":
      return "Flat";
    case "CsharpDflat":
      return "Sharp";
    case "D":
      return "Flat";
    case "DsharpEflat":
      return userPref || "Flat"; // arbitrary.  6 accidentals either way
    case "E":
      return "Sharp";
    case "F":
      return "Flat";
    case "FsharpGflat":
      return "Sharp";
    case "G":
      return "Flat";
    case "GsharpAflat":
      return userPref || "Sharp";
  }
}
